import React from "react";

import { Box } from "@mui/material";
import { Typography } from "@mui/material";
import theme from "../ThemeSettings/Theme";
import { useNavigate } from "react-router-dom";

import SalusLogoPrimary from "../LogoMedia/salus-logo-primary.png";

type PageLogoProps = {};

function PageLogo(props: PageLogoProps) {
  const navigate = useNavigate();

  return (
    <Box sx={{ flexShrink: 0, display: "flex", flexDirection: "row", position: "relative" }}>
      <Box
        component={"img"}
        src={SalusLogoPrimary}
        alt="Salus"
        style={{
          width: "3rem",
          height: "3rem",
          cursor: "pointer",
        }}
      />
      <Typography
        variant="h3"
        noWrap
        sx={{
          fontWeight: 500,
          background: `linear-gradient(to right top, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          lineHeight: 1,
          cursor: "pointer",
        }}
        onClick={() => navigate("/")}
      >
        SALUS
      </Typography>
    </Box>
  );
}

export default PageLogo;
